module.exports = __webpack_public_path__ + "img/marketing.9e5b94cc.webp";